import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
      socials: [
          {
              name: "TikTok",
              icon: "mdi-music-note",
              handle: "@budokwai.garbsen",
              url: "https://www.tiktok.com/@budokwai.garbsen",
              cta: "Kurzclips ansehen",
              tagline: "Technik, Spaß und Highlights im schnellen Format.",
              gradient: "bg-tiktok"
          },
          {
              name: "Instagram",
              icon: "mdi-instagram",
              handle: "@sc_budokwai_garbsen",
              url: "https://www.instagram.com/sc_budokwai_garbsen",
              cta: "Fotos & Stories",
              tagline: "Trainingsmomente, Turniere & Team-Stories.",
              gradient: "bg-instagram"
          },
          {
              name: "Facebook",
              icon: "mdi-facebook",
              handle: "@scbudokwai",
              url: "https://www.facebook.com/scbudokwai",
              cta: "Neuigkeiten folgen",
              tagline: "Ankündigungen, Events und Rückblicke.",
              gradient: "bg-facebook"
          }
      ]
  },
  mutations: {},
  actions: {},
  modules: {},
});
